export default __webpack_public_path__ + "static/media/landingResults.676db96c.jpg";